/* import __COLOCATED_TEMPLATE__ from './slack.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();